import React from 'react';
import { renderToString } from "react-dom/server";
import HtmlDocumentLayout from "./components/HtmlDocumentLayout";
import { SearchResultsObj } from "./types";

export const generateHtmlWithItems = (items: SearchResultsObj[], publicationDates, publicationKinds) => {

    const kindCodes = publicationKinds?.join('_OR_');
    const element = document.createElement('a');
    const file = new Blob(
        [
            renderToString(
                <HtmlDocumentLayout
                    data={items}
                    kinds={publicationKinds}
                    publicationDates={publicationDates}
                />,
            ),
        ],
        { type: 'text/html' },
    );
    const today = new Date();
    const myDate = `${today.getFullYear()}${('0' + (today.getMonth() + 1)).slice(-2)}${(
        '0' + today.getDate()
    ).slice(-2)}`;
    const fileName = `resultlist_${myDate}_KI=${kindCodes}_AND_PD[${publicationDates}].html`;
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
};

export const numberWithSpaces = (number: number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}